import { ATTRS, TAGS } from '../constants';
import { Entity } from '../types';
import { DeviceObjectReferenceEntity } from './DeviceObjectReference';

export class DeviceElementEntity implements Entity {
  public static fromXML(xml, matchIDs: any) {
    const attrs = xml._attributes;
    const isoId = attrs[ATTRS.DeviceElement.DeviceElementId];
    const id = matchIDs[isoId] ? matchIDs[isoId].id : isoId;

    const deviceObjectReferences = (xml[TAGS.DeviceObjectReference] || []).map(
      (refXml) => DeviceObjectReferenceEntity.fromXML(refXml).entity
    );
    return {
      entity: new DeviceElementEntity(
        id,
        parseInt(attrs[ATTRS.DeviceElement.DeviceElementObjectId], 10),
        attrs[ATTRS.DeviceElement.DeviceElementType],
        attrs[ATTRS.DeviceElement.DeviceElementNumber],
        attrs[ATTRS.DeviceElement.ParentObjectId],
        attrs[ATTRS.DeviceElement.DeviceElementDesignator],
        deviceObjectReferences
      ),
      isoId,
    };
  }
  public type = TAGS.DeviceElement;

  constructor(
    public id: string,
    public objectId: number,
    public elementType: string,
    public elementNumber: number,
    public parentObjectId: number,
    public designator?: string,
    public deviceObjectReferences?: DeviceObjectReferenceEntity[]
  ) {}

  public toXML(xmlId: string) {
    return {
      _attributes: {
        [ATTRS.DeviceElement.DeviceElementId]: xmlId,
        [ATTRS.DeviceElement.DeviceElementObjectId]: this.objectId,
        [ATTRS.DeviceElement.DeviceElementType]: this.elementType,
        [ATTRS.DeviceElement.DeviceElementNumber]: this.elementNumber,
        [ATTRS.DeviceElement.ParentObjectId]: this.parentObjectId,
        [ATTRS.DeviceElement.DeviceElementDesignator]: this.designator,
      },
      [TAGS.DeviceObjectReference]: (this.deviceObjectReferences || []).map((ref) => ref.toXML()),
    };
  }
}
